/**
 * @desc 新建
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.WarehouseCostRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/warehouseCost/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
